import Handlebars from 'handlebars';
import Widget from '../modules/Widget';

const { document } = window;

const DEFAULT_LAYOUT = `
  {{#each items}}
    <option value="{{this.value}}">{{this.label}}</option>
  {{/each}}
`;

class PageSizeSelect extends Widget {
  defaultParams = {
    containerClassName: '',
    items: [
      { label: '36 per page', value: 36 },
      { label: '72 per page', value: 72 },
      { label: '108 per page', value: 108 },
    ],
    template: DEFAULT_LAYOUT,
  };

  constructor(params) {
    super(params);

    this.layoutTemplate = Handlebars.compile(this.params.template);

    const element = document.createElement('select');
    element.className = this.params.containerClassName;
    this.mainElement = element;

    this.mainElement.addEventListener('change', (e) => this.handleChange(e.target.value));
  }

  didMount() {
    this.updateSelectedOption();
  }

  didUpdate() {
    this.updateSelectedOption();
  }

  updateSelectedOption() {
    let { limit } = this.state.filter;
    if (!limit) {
      limit = parseInt(this.params.items[0].value, 10);
      this.handleChange(limit);
    }
    const option = this.mainElement.querySelector(`option[value="${limit || ''}"]`);
    if (option) {
      option.selected = true;
    }
  }

  handleChange = (limit) => {
    this.setFilter({
      limit: limit || null,
    });
  }

  render() {
    this.mainElement.innerHTML = this.layoutTemplate({
      items: this.params.items,
    });
    return this.mainElement;
  }
}

export default (params) => {
  return new PageSizeSelect(params);
};
